<template>
    <el-dialog class="dialog" v-if="dialogDetails" title="任务详情" :visible.sync="dialogDetails" :close-on-click-modal="false" width="70vw" top="5vh">
        <el-tabs v-model="activeId" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="1">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                    <el-collapse class="collapse" v-model="activeCollapseId">
                        <el-collapse-item :name="1" v-loading="formLoading">
                            <template slot="title">
                                <span>主要任务</span> 
                                <!-- <el-button class="rightButn" size="mini" type="primary">常规任务设定</el-button> -->
                            </template>
                            <div class="collapse-title">{{taskName}}</div>
                            <el-form class="form-flex" ref="taskForm" :model="taskForm" label-width="170px">
                                <el-form-item label="延后时间：" v-if="status != '-1'">
                                    <el-date-picker size="small" v-model="delayCompleteTime" type="datetime" :disabled="status != 0 && status != 2" :picker-options="pickerOptions" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="width:18vw" @change="handleComplete"></el-date-picker>
                                </el-form-item>

                                <template  v-for="(item,index) in taskForm.typelist">
                                    <el-form-item :key="index" :label="item.name+'：'" :prop="item.required ? `typelist.${index}.fieldValue` : null" :rules="item.required ? { required: true, message:`${item.name}不能为空`, trigger: ['change','blur']} : null" v-if="!item.iftable && item.id !== 6 && item.id !== 31 && item.id !== 32 && item.id !== 33 && item.id !== 34 && item.id !== 48 && item.fieldValue && item.type!='upload'">
                                        <!-- 时间 -->
                                        <el-date-picker v-if="item.type == 'date'" size="small" v-model="item.fieldValue" type="datetime" disabled format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" style="width:18vw"></el-date-picker>
                                        
                                        <!-- 下拉选择 -->
                                        <template v-if="item.type == 'select'">
                                            <el-select v-if="item.id == 2" size="small" v-model="item.fieldValue" disabled filterable clearable :placeholder="'请选择'+item.name" style="width:18vw">
                                                <el-option v-for="(selectItem,selectIndex) in projectOptions" :key="selectIndex" :label="selectItem.name" :value="selectItem.id"></el-option>
                                            </el-select>

                                            <el-select v-else-if="item.id == 56" size="small" v-model="item.fieldValue" disabled filterable clearable :placeholder="'请选择'+item.name" style="width:18vw">
                                                <el-option v-for="(selectItem,selectIndex) in typeOptions" :key="selectIndex" :label="selectItem.name" :value="selectItem.id+''"></el-option>
                                            </el-select>

                                            <el-select v-else size="small" v-model="item.fieldValue" disabled filterable clearable :placeholder="'请选择'+item.name" style="width:18vw">
                                                <el-option v-for="(selectItem,selectIndex) in item.valuelist" :key="selectIndex" :label="selectItem" :value="selectItem"></el-option>
                                            </el-select>
                                        </template>

                                        <!-- 级联选择 -->
                                        <el-cascader v-if="item.type == 'multiple_cascader'" size="small" v-model="item.fieldValue" :options="tagOptions" :props="props" disabled filterable clearable placeholder="请选择标签" style="width:18vw"></el-cascader>

                                        <el-input v-if="item.type == 'input' || item.type == 'number'" size="small" v-model="item.fieldValue" disabled :placeholder="'请输入'+item.name" clearable style="width:18vw"></el-input>
                                        
                                        <!-- switch 开关 -->
                                        <el-switch v-if="item.type == 'switch'" v-model="item.fieldValue" disabled active-color="#13ce66" inactive-color="#ff4949"></el-switch>

                                        <!-- 规格-->
                                        <el-table v-else-if="item.type == 'inputTable'" class="grayTableTile" size="small" :data="item.fieldValue" border  style="width:90%">
                                            <el-table-column v-for="(headItem,headIndex) in speHeader" :key="headIndex" :label="headItem">
                                                <template slot-scope="scope">
                                                    <span>{{scope.row[headItem]}}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>

                                        <!-- 尺寸 -->
                                        <el-table v-if="item.type == 'sizeList'" class="grayTableTile" size="small" :data="sizeList" border max-height="400"  style="width:90%; margin-bottom:3px">
                                            <el-table-column label="尺寸" min-width="120">
                                                <template slot-scope="scope">{{scope.row.width}} * {{scope.row.height}}</template>
                                            </el-table-column>
                                            <el-table-column label="大小" prop="picsize" min-width="100"></el-table-column>
                                            <el-table-column label="类型" prop="pictype" min-width="80"></el-table-column>
                                            <el-table-column label="说明" prop="picdesc" min-width="300"></el-table-column>
                                        </el-table>

                                        <!-- 渠道 -->
                                        <div v-if="item.type == 'channelList'">
                                            <el-table  class="grayTableTile" size="small" :data="channelList" border max-height="400" style="width:90%;margin-top:10px;margin-bottom:3px">
                                                <el-table-column label="渠道" prop="channelname" min-width="100"></el-table-column>
                                                <el-table-column label="应用场景" prop="channelname" min-width="100"></el-table-column>
                                                <el-table-column label="尺寸" min-width="110">
                                                    <template slot-scope="scope">{{scope.row.width}} * {{scope.row.height}}</template>
                                                </el-table-column>
                                                <el-table-column label="大小" prop="picnum" min-width="100"></el-table-column>
                                                <el-table-column label="类型" prop="pictype" min-width="80"></el-table-column>
                                                <el-table-column label="说明" prop="picdesc" min-width="300"></el-table-column>
                                            </el-table>
                                        </div>

                                        <!-- 富文本 -->
                                        <!-- <markdown-editor v-if="item.type == 'textarea'" v-model="item.fieldValue" disabled mode="wysiwyg" language="zh-CN" height="30vh" style="width:90%;margin-bottom:3px" /> -->
                                        <div class="markdown" v-if="item.type == 'textarea'" v-html="item.fieldValue" ></div>
                                       
                                        <!-- 样板图 -->
                                        <!-- <div v-else-if="item.type == 'upload'" class="swiper">
                                            <el-carousel indicator-position="outside" :autoplay="false" height="220px">
                                                <el-carousel-item v-for="(imgItem,imgIndex) in item.fieldValue" :key="imgIndex">
                                                   <div class="img" :style="{'background-image': 'url('+imgItem.thumbnailImageUrl+')'}" @click="handleDownload(imgItem)"></div>
                                                </el-carousel-item>
                                            </el-carousel>
                                        </div> -->

                                        <!-- 提示 -->
                                        <el-popover v-if="item.desc" popper-class="gray-popper" placement="right" width="500" trigger="hover" :content="item.desc">
                                            <i class="el-icon-question" slot="reference" style="cursor: pointer;" />
                                        </el-popover>

                                    </el-form-item>
                                </template>
                            </el-form>

                            <!-- 审批 -->
                            <div class="butn-box" style="text-align:center" v-if="(status == 0 || status == 2) && accessPoint['allduty:dutygive']">
                                <el-radio-group v-model="isApprove" size="small">
                                    <el-radio :label="1" border>审批通过</el-radio>
                                    <el-radio :label="2" border>拒绝</el-radio>
                                </el-radio-group>
                            </div>
                        </el-collapse-item>

                        <el-collapse-item :name="2" v-if="status == 0 || status == 2 || status == 1">
                            <template slot="title">
                                <span>分配任务</span> 
                                <!-- <el-button class="rightButn" size="mini" type="primary">常规任务设定</el-button> -->
                            </template>
                            <div class="content">
                               <template v-if="isApprove == 1">
                                   <div class="selectBox" v-if="(status == 0 || status == 2) && accessPoint['allduty:dutygive']">
                                       <span class="label">可分配：</span>
                                       <el-select v-model="designerIds" size="small" filterable placeholder="请选择">
                                            <el-option v-for="item in designerOptions" :key="item.id" :label="item.realname" :value="item.id"></el-option>
                                        </el-select>
                                        <el-button class="butn" type="primary" size="small" icon="el-icon-plus" circle @click="handleAddDes"></el-button>
                                   </div>
                                   
                                   <div class="tag-box">
                                        <span class="label">已分配：</span>
                                        <div class="tagBox" >
                                            <el-tag class="tag" v-for="tag in designerTags" :key="tag.id" :closable="(status == 0 || status == 2) && accessPoint['allduty:dutygive']" type="success" @close="handleClose(tag)"> {{tag.realname}}</el-tag>
                                        </div>
                                   </div>
                               </template>
                               
                               <template v-if="isApprove == 2">
                                    <el-input class="textarea" type="textarea" :rows="5" placeholder="请输入拒绝理由" v-model="refuse"></el-input>
                               </template>

                               <!-- 提交 -->
                               <div class="footer-box" v-if="(status == 0 || status == 2) && accessPoint['allduty:dutygive']"> 
                                    <el-button class="butn" type="primary" @click="handleSubmitDes" >提交</el-button>
                                    <div class="message-box">
                                        <span class="label">通知方式：</span>
                                        <el-checkbox v-model="designerSendMail" :true-label="1" :false-label="0">邮箱</el-checkbox>
                                    </div>
                                </div>
                            </div>
                        </el-collapse-item>

                        <el-collapse-item :name="3" v-if="status == -1">
                            <template slot="title">
                                <span>拒绝理由</span> 
                            </template>
                            <div class="content">
                               <template>
                                    <el-input class="textarea" type="textarea" :rows="5" readonly v-model="statusStr"></el-input>
                               </template>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-scrollbar>
            </el-tab-pane>

            <el-tab-pane label="素材文件" name="2" v-if="accessPoint['allduty:download']">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                    <el-table :show-header="false" :data="materialList">
                        <el-table-column width="120">
                            <template slot-scope="scope">
                                <el-image style="width: 100px; height: 100px" :src="scope.row.thumbnailImageUrl" fit="contain"></el-image>
                            </template>
                        </el-table-column>

                        <el-table-column show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{scope.row.fileName}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="100px">
                            <template slot-scope="scope">
                                <span>{{scope.row.type}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="120px">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" @click="handleDownload(scope.row)">下载<i class="el-icon-download el-icon--right"></i></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-scrollbar>
            </el-tab-pane>

            <el-tab-pane label="完稿文件" name="3" v-if="status != 0 && status != '-1'">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                    <template>
                        <div class="item-box" v-if="(status == 1 || status == 3) && finishDesc">
                            <span class="label">完稿说明：</span>
                            <div class="textArea">{{finishDesc}}</div>
                        </div>
                        <div class="item-box" v-if="status == 2 && accessPoint['allduty:okfileupload']">
                            <span class="label">完稿说明：</span>
                            <el-input class="textarea" type="textarea" :rows="4" placeholder="请输入完稿说明" v-model="finishDesc" style="width:80%"></el-input>                
                        </div>
                    </template>

                    <el-table :show-header="false" :data="completeFileDetail" v-if="completeFileDetail && completeFileDetail.length > 0 && (status == 1 || status == 3 || status == 2)" style="margin-bottom:20px">
                        <el-table-column width="120">
                            <template slot-scope="scope">
                                <img :src="scope.row.thumbnailImageUrl" style="width:100px; height:auto" />
                            </template>
                        </el-table-column>

                        <el-table-column>
                            <template slot-scope="scope">
                                <span>{{scope.row.fileName}}</span>
                            </template>
                        </el-table-column>

                        <el-table-column width="220px" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" type="primary" @click="handleDownload(scope.row)">下载<i class="el-icon-download el-icon--right"></i></el-button>
                                <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="accessPoint['allduty:okfiledelete'] && status!=3">删除<i class="el-icon-delete el-icon--right"></i></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                
                    <div class="item-box" v-if="(status==2 || status==1) && accessPoint['allduty:okfileupload']">
                        <span class="label">上传完稿文件：</span>
                        <simple-uploader ref="uploader" @onSuccess="handleSuccess" @onRemove="handleRemove" style="min-width:360px; width:50%"></simple-uploader>

                        <!-- <el-upload class="upload-demo" drag
                            :action= "updateUrl"
                            :multiple="true"
                            :show-file-list="true"
                            :limit="maxNum"
                            :file-list="fileList"
                            :on-remove="handleRemove"
                            :on-error="handleError"
                            :on-exceed="handleExceed"
                            :on-success="handleSuccess"
                        >
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                            <div slot="tip" class="el-upload__tip" style="font-size:10px;margin-top:5px;line-height: 16px;">最多上传10个文件,且单个文件不超过 1G</div>
                        </el-upload> -->
                    </div>

                    
                    <!-- 提交 -->
                    <div class="footer-box" v-if="(status==2 || status==1)"> 
                        <el-button class="butn" type="primary" :loading="saveLoding" @click="handleSave" >保存</el-button>
                        <div class="message-box">
                            <span class="label">通知方式：</span>
                            <el-checkbox v-model="finishSendMail" :true-label="1" :false-label="0">邮箱</el-checkbox>
                        </div>
                    </div>
                </el-scrollbar>
            </el-tab-pane>

            <el-tab-pane label="确认定稿" name="4" v-if="status == 1">
                <el-scrollbar wrap-class="scrollbar-wrapper">
                    <!-- 审批 -->
                    <div class="content">
                        <el-radio-group class="butnGroup" v-model="isFinalize" size="small">
                            <el-radio :label="1" border v-if="accessPoint['allduty:confirmfile']">确认通过</el-radio>
                            <el-radio :label="2" border v-if="accessPoint['allduty:updatefile']">修改</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="item-box" v-if="isFinalize == 2">
                        <span class="label">修改理由：</span>
                        <el-input class="textarea" type="textarea" :rows="4" placeholder="请输入修改理由" v-model="editReason" style="width:80%"></el-input>
                    </div>

                    <div class="footer-box"> 
                         <el-button class="butn" type="primary" @click="handleSubmitFinash">提交</el-button>
                        <div class="message-box" v-if="isFinalize == 2">
                            <span class="label">通知方式：</span>
                            <el-checkbox v-model="confirmSendMail" :true-label="1" :false-label="0">邮箱</el-checkbox>
                        </div>
                    </div>
                    
                </el-scrollbar>
            </el-tab-pane>

        </el-tabs>
    </el-dialog>
</template>

<script>
import MarkdownEditor from '@/components/MarkdownEditor'
import { projectList_ajax,taskTypeList_ajax, artFlowChoiceLabel_ajax, artFlowDetail_ajax, artChannelList_ajax, artCompleteTimes_ajax, designerListByRoleIds_ajax, assignDesigner_ajax, artFlowModifyStatus_ajax, saveCompleteFile_ajax, deleteRecycleFileFolder_ajax,saveUploadFlowFile_ajax} from '@File~/api/file'
import { apiUrl } from '@File~/api/env'

import SimpleUploader from '../../materialCenter/components/simpleUploader.vue'
export default {
    components: {MarkdownEditor,SimpleUploader},
    data() {
        return {
            dialogDetails: false,
            activeId:'1',
            activeCollapseId:[1,2,3],
            formLoading: false,

            status:'',
            flowId:'',
            delayCompleteTime:'', // 延后时间
            refuse: '', // 拒绝
            finishDesc:'', // 完稿说明
            statusStr: '', // 拒绝理由

            // 时间
            pickerOptions:{
                // 当前日期之前的日期不可选
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },

            taskId:'', // 任务id 
            taskName:'', // 任务名称
            taskForm:{
                typelist :[]
            },

            projectOptions:[], // 项目列表
            typeOptions: [], // 任务分类

            // 标签
            tagOptions:[],
            props:{
                multiple: true,
                expandTrigger: 'hover',
                value:'id',
                label:'name',
                children:'labelList'
            },

            channelListAll:[], // 所有渠道列表
            channelList:[], // 渠道列表
            sizeList:[], // 尺寸列表

            materialList:[], // 素材管理

            isApprove: 1,// 是否审批
            designerIds:'',
            designerOptions:[],
            designerTags:[],
            checkedDesignerIds:[], // 查询的已选设计师

            editReason:'',

            // 上传完成稿
            updateUrl: this.$store.getters.uploadUrl,

            maxNum:10,
            fileList:[],

            saveLoding: false,

            // 完稿 文件
            completeFileDetail:[],

            isFinalize: 1, // 确认定稿

            speHeader:[], // 规格表头

            accessPoint: this.$store.getters.accessPoint, //权限点
            
            // 是否发送邮件
            designerSendMail:0, // 分配设计师 0否 1是
            finishSendMail:0, // 上传完稿文件 0否 1是
            confirmSendMail:0, // 确认完稿 修改时发送邮件

        }
    },
    methods: {
        init(row) {
            this.dialogDetails = true
            this.activeId = '1'
            this.activeCollapseId = [1,2,3]
            this.formLoading = false

            this.taskForm.typelist = []
            this.channelListAll = [] // 所有渠道列表
            this.channelList = [] // 渠道列表
            this.sizeList = [] // 尺寸列表

            this.refuse = ''

            this.materialList = []
            this.completeFileDetail = []

            this.isApprove = 1
            this.designerIds = ''
            this.designerOptions = []
            this.designerTags = []
            this.editReason = ''
            this.finishDesc = ''
            this.statusStr = ''

            this.status = row.status
            this.flowId = row.id
            this.delayCompleteTime = ''
            this.checkedDesignerIds = []

            this.speHeader = []

            this.isFinalize = 1

            this.fileList = []
            this.saveLoding = false

            this.getProject() // 项目列表
            this.getLabels() // 标签列表

            this.$nextTick(() => {
                this.getDetails(row.id) // 获取详情
            })
            
        },

         // 项目列表
        getProject() {
            projectList_ajax().then(response => {
                if(response.code == 1) {
                    this.projectOptions = response.data
                }
            })
        },
        // 项目分类
        getTaskType() {
            taskTypeList_ajax({taskIds:[this.taskId]}).then(response => {
                if (response.code == 1) {
                this.typeOptions = response.data
                }
            })
        },

        // 获取标签列表
        getLabels(){
            artFlowChoiceLabel_ajax().then(response => {
                if(response.code == 1) {
                    this.tagOptions = response.data
                }
            })
        },

        // 获取渠道列表
        getChannelList(data) {
            if(this.taskId == 6 || this.taskId == 9) {
                const type = this.taskId == 6 ? 1 : this.taskId == 9 ? 2 : null
                artChannelList_ajax(type).then(response => {
                    this.channelListAll = JSON.parse(JSON.stringify(response.data))
                    data.forEach(d => {
                        if(d.type == 'sizeList' || d.type == 'channelList') { // 尺寸列表
                            d.fieldValue.forEach(value => {
                                this.channelListAll.forEach(channel => {
                                    if(value == channel.id) {
                                        if(d.type == 'sizeList') {
                                            this.sizeList.push(channel)
                                        }

                                        if(d.type == 'channelList') {
                                            console.log('channel ====')
                                            this.channelList.push(channel)
                                        }
                                    }
                                })
                            });
                        }
                    });
                })
            }
        },

        // 获取设计师列表
        getDesigner() {
            const roleIds = this.$store.getters.roles.toString()
            designerListByRoleIds_ajax(roleIds).then(response => {
                if(response.code == 1) {
                    this.designerOptions = response.data
                    this.designerIds = response.data[0].id

                    // console.log('==========22222',this.checkedDesignerIds)

                    // 初始化已选设计师列表
                    this.checkedDesignerIds.forEach(c => {
                        this.designerOptions.forEach(d => {
                            if(c == d.id) {
                                this.designerTags.push(d)
                            }
                        })
                    })
                    
                }
            })
        },

        // 获取详情
        getDetails(flowId) {
            this.formLoading = true
            artFlowDetail_ajax(flowId).then(response => {
                this.formLoading = false
                if(response.code == 1) {
                    this.taskId = response.data.taskId
                    this.taskName = response.data.taskName

                    const data = JSON.parse(JSON.stringify(response.data))

                    this.delayCompleteTime = data.delayCompleteTime
                    this.checkedDesignerIds = data.designerId ? data.designerId : []

                    this.completeFileDetail = JSON.parse(data.completeFileDetail)
                    this.finishDesc = data.completeStr
                    this.statusStr = data.statusStr
                    // console.log('==========111111',this.checkedDesignerIds)

                    this.initTaskList(data.processDetail)

                    this.getChannelList(data.processDetail)  // 获取渠道列表

                    this.getDesigner() // 设计师列表
                    
                    this.getTaskType()// 项目分类

                }
            })
        },

        // 初始化任务字段列表
        initTaskList(data) {
            this.taskForm.typelist = data.map(v => {
                if(v.type == 'channelList'|| v.type == 'sizeList') {
                    if(v.fieldValue) {
                        v.fieldValue = v.fieldValue.split(",")
                    } else {
                        v.fieldValue = null
                    }
                    
                }else if(v.type == 'upload' || v.type == 'inputTable' || v.type == 'multiple_cascader') {
                    if(v.fieldValue && v.fieldValue != '[]') {
                        v.fieldValue = JSON.parse(v.fieldValue)
                    } else {
                        v.fieldValue = null
                    }
                } else if(v.id == 2) {
                    v.fieldValue = Number(v.fieldValue)
                }

                // 素材文件
                if(v.id == 6 || v.id == 31 || v.id == 32 || v.id == 33 || v.id == 34 || v.id == 48 || v.id == 7 || v.id == 10 || v.id == 18 || v.id == 22 || v.id == 38 || v.id == 39 || v.id == 40 || v.id == 41 || v.id == 42 || v.id == 43) {
                    if(v.fieldValue) {
                        v.fieldValue.forEach(fielList => {
                            fielList.type = v.name
                        })
                        this.materialList = this.materialList.concat(v.fieldValue)
                    }
                }
                
                if(v.iftable){
                    this.speHeader.push(v.name)
                }

                return v
            })

            //console.log('规格表头====',this.taskForm.typelist)
        },

        // 修改工单延后时间
        handleComplete() {
            artCompleteTimes_ajax(this.flowId,this.delayCompleteTime).then(response => {
                if(response.code == 1) {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });

                    this.$emit('againList')
                }
            })
        },

        // 分配添加设计师
        handleAddDes() {
            let pass = true
            this.designerTags.forEach(tag => {
                if(tag.id == this.designerIds) {
                    pass = false
                }
            })

            if(pass) {
                this.designerOptions.forEach(m => {
                    if(m.id == this.designerIds) {
                        this.designerTags.push(m)
                    }
                })

                this.$nextTick(() => {
                    this.designerIds = this.designerOptions[0].id 
                }) 
            }
        },

        // 关闭tag
        handleClose(tag) {
            this.designerTags.splice(this.designerTags.indexOf(tag), 1);
            
        },

        // 提交 分配设计师
        handleSubmitDes() { 
            if(this.isApprove == 1) { // 审批通过
                if(this.designerTags.length == 0) {
                    this.$message({
                        type: 'error',
                        message: '请选择设计师'
                    });
                } else {
                    let designerIds = []
                    this.designerTags.forEach(d => {
                        designerIds.push(d.id)
                    })

                    const data = {
                        flowId: this.flowId,
                        designerIds: designerIds,
                        roleIds: this.$store.getters.roles,
                        userId: this.$store.getters.userId,
                        sendMail: this.designerSendMail
                    }
                    assignDesigner_ajax(data).then(response => {
                        if(response.code == 1) {
                            const status = this.status == 0 || this.status == 2 ? 2 : null
                            this.handleStatus(status,'','',() => {
                                this.$message({
                                    type: 'success',
                                    message: '设计师分配成功'
                                });
                            })
                        }
                    })
                }
            } else { // 拒绝
                this.handleStatus('-1',this.refuse,this.designerSendMail)
            }
        },

        // 修改工单状态
        handleStatus(status, statusStr, sendMail, callback) {
            // 修改工单状态
            const data = {
                userId: this.$store.getters.userId,
                flowId: this.flowId,
                status: status,
                statusStr: statusStr,
                sendMail: sendMail
            }
            artFlowModifyStatus_ajax(data).then(response => {
                this.$emit('againList')
                this.dialogDetails = false
                if(callback) {
                    callback()
                }
            })
        },

        // 保存完稿文件
        handleSave() {
            if(this.fileList.length == 0) {
                this.$message({
                    type: 'error',
                    message: '请上传完稿文件'
                });
            } else {
                this.saveLoding = true
                let fileIds = []

                const result = JSON.parse(JSON.stringify(this.fileList))
                result.forEach(v => {
                    // fileIds.push(v.response.data)
                    fileIds.push(v.fileId)
                })

                const data = {
                    flowId: this.flowId,
                    fileIds: fileIds,
                    completeStr: this.finishDesc,
                    sendMail: this.finishSendMail,
                    userId: this.$store.getters.userId
                }

                // console.log(data)
                saveCompleteFile_ajax(data).then(response => {
                    if(response.code == 1) {
                        // 修改工单状态
                        this.handleStatus(1,'','',() => {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            });
                        })
                    }
                })
            }
        },

        // 确定完稿
        handleSubmitFinash() {
            if(this.isFinalize == 1) {
                this.handleStatus(3,'','',() => {
                    this.$message({
                        type: 'success',
                        message: '确定完稿'
                    });
                })
            } else {
                this.handleStatus(-2,this.editReason, this.confirmSendMail)
            }
        },

        // 切换 tabs
        handleClick() {
            
        },

        // 下载
        handleDownload(item) {
            // console.log('下载图片：',item)
            // 创建form 表单
                var form = document.createElement('form')
                document.body.appendChild(form)
                form.setAttribute('style','display:none');
                form.setAttribute('method','post');
                form.setAttribute('action',this.$store.getters.downloadUrl);//下载文件的请求路径
                
                // 创建表单里 input 元素
                var tempInput = document.createElement("input");
                tempInput.type = "hidden";
                tempInput.name = 'fileId';
                tempInput.value = item.id;
                form.appendChild(tempInput);

                var tempInput2 = document.createElement("input");
                tempInput2.type = "hidden";
                tempInput2.name = 'userId';
                tempInput2.value = this.$store.getters.userId;
                form.appendChild(tempInput2);

                form.submit()
                document.body.removeChild(form)
        },

        // 删除
        handleDelete(item) {
            console.log(item)
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const data = {
                    "fileItems":[
                        {
                            id:item.id,
                            type: item.fileType
                        }
                    ]
                }
                deleteRecycleFileFolder_ajax(data).then(response => {
                    if(response.code == 1) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.completeFileDetail.splice(this.completeFileDetail.indexOf(item), 1) 
                    }
                })
                
            }).catch(() => {
                        
            });
        },
        
        // 分片上传
        handleSuccess(file, fileList) {
            // 工单文件上传
            const data = {
                fileIds:[file],
                userId:this.$store.getters.userId
            }
            saveUploadFlowFile_ajax(data).then(response => {
                if(response.code == 1) {
                    // field.fieldValue = response.data
                    this.fileList = fileList
                }
            })
        },

        // 上传成功后删除
        handleRemove(fileList) {
            this.fileList = fileList
        }
        // ============== element 上传 ===========
        // 成功上传图片
        // handleSuccess(response,file,fileList) {
            
        //     console.log('上传成功：', this.fileList)

        //     // 工单文件上传
        //     const data = {
        //         fileIds:[response.data],
        //         userId:this.$store.getters.userId
        //     }
        //     saveUploadFlowFile_ajax(data).then(response => {
        //         if(response.code == 1) {
        //             // field.fieldValue = response.data
        //            this.fileList = fileList
        //         }
        //     })
        // },

        // // 删除图片
        // handleRemove(file , fileList) {
        //     this.fileList = fileList
        //     console.log('上传成功：', this.fileList)
        // },

        // // 本地上传失败
        // handleError(err) {
        //     this.$message({
        //     message: '上传失败',
        //     type: 'error'
        //     })
        // },

        // // 超出上传数量限制
        // handleExceed() {
        //     this.$message.warning('最多只能上传'+ this.maxNum +'个文件')
            
        // }

    }
}
</script>

<style lang="scss" scoped>
    .dialog{
        ::v-deep .el-dialog__body{
            padding: 0 20px 20px;
           
        }
        ::v-deep .el-tab-pane{
            height:calc(100vh - 25vh);
        }
        ::v-deep .el-scrollbar{
            height: 100%;
        }
        ::v-deep .scrollbar-wrapper {
            overflow-x: hidden !important;
        }
        .el-scrollbar__bar.is-vertical {
            right: 0px;
        }
        ::v-deep .el-collapse-item__content{
            padding-left: 20px;
        }
        .collapse-title{
            color: #989898;
            padding: 5px 0;
            font-size: 16px;
        }
        .swiper{
            width:85%;
            height: auto;
            overflow: hidden;
            background:#00050c;
            padding: 8px 0;
            .img{
                cursor: pointer;
                width:auto;
                height: 220px;
                // background-image: url('../../assets/banner1.png');
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center center;
            }
        }

        ::v-deep .el-collapse-item__header{
            padding: 0 10px;
            background: #dfeaf7;
            height: 32px;
            line-height: 32px;
        }
        .content{
            width: 85%;
            margin: 15px auto 0;
            .butn{
                margin: 0 10px;
            }
            .tagBox{
                margin: 10px 0 20px;
                padding: 10px 10px;
                width: 100%;
                height: 130px;
                background: #f3f3f3;
                box-shadow: 0 0 3px inset rgba(0,0,0,.28);
                .tag{
                    margin: 5px 5px;
                }
            }
            .submitButn {
                display: block;
                margin: 0 auto;
            }
            .textarea{
                margin-bottom:20px;
               
                ::v-deep .el-textarea__inner{
                    background: #ffffff;
                    box-shadow: 0 0 3px inset rgba(0,0,0,.28);
                }
            }
            .butnGroup{
                width: 100%;
                text-align: center;
                margin-bottom: 40px;
            }
        }
        .tag-box, .selectBox{
            .label{
                width: 65px;
                line-height: 36px;
                text-align: left;
                font-size: 14px;
                color: #606266;
                font-weight: bold;
                margin-right: 10px;
            }
        }
        .tag-box{
            display:flex;
        }
        .item-box{
            display: flex;
            flex-flow: row nowrap;
            margin-bottom:20px;
            .label{
                width: 130px;
                line-height: 36px;
                text-align: right;
                font-size: 14px;
                color: #606266;
                font-weight: bold;
                margin-right: 10px;
            }

            .textarea{
                ::v-deep .el-textarea__inner{
                   
                    background: #ffffff;
                    box-shadow: 0 0 3px inset rgba(0,0,0,.28);
                    
                }
            }
            .textArea{
                min-height: 96px;
                width: 80%;
                background: #ffffff;
                box-shadow: 0 0 3px inset rgba(0,0,0,.28);

                display: block;
                padding: 5px 15px;
                line-height: 1.5;
                box-sizing: border-box;
                font-size: inherit;
                color: #606266;
                border: 1px solid #dcdfe6;
                border-radius: 4px;
                transition: border-color .2s cubic-bezier(0.645, 0.045, 0.355, 1);
            }
        }
        .line{
            margin: 30px 0 40px;
            width: 100%;
            height: 3px;
            background: #67a7ff;
        }

        .submitButn {
            display: block;
            margin: 0px auto;
        }

        ::v-deep .el-input.is-disabled .el-input__inner{
            background-color: rgba(245,247,250,.68);
            color: #606266;
        }
        ::v-deep .el-tag.el-tag--info{
            color: #606266;
        }

        ::v-deep .disable .tui-editor-contents{
            background-color: rgba(245,247,250,.68);
            color: #606266;
        }

        .markdown{
            width:90%;
            margin-bottom:3px; 
            height:30vh;
            line-height: 1.3;
            background-color: rgba(209,218,230,.2);
            border: 1px solid#dfe4ed;
            color: #606266;
            overflow: auto;
            padding: 16px 25px 0 25px;
        }
    }

    .footer-box{
        margin: 20px auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        .butn{
            padding: 12px 20px;
        }
        .message-box{
            margin-left: 100px;
            .label{
                font-size: 15px;
                color: #7b7b7b;
            }
            ::v-deep .el-checkbox{
                color: #7b7b7b;
            }
        }
    }
</style>